module.exports = __webpack_public_path__ + "img/21.ae03718e.png";